module.exports = __webpack_public_path__ + "static/media/logo-riotickets.cb41b467.png";